/**
 * Created by BFR on 13/03/2020.
 */
define('suppliersMainRouter',[
  'require',
  'module',
  'marionette',
  'app',
  'underscore',
  'settings',
  'supplierImprintTechnologiesView',
  'contentShowController',
  'itemPagesNameMixin'
], function (
  require,
  module,
  Marionette,
  App,
  _,
  Settings,
  SupplierImprintTechnologiesView,
  ContentShowController,
  ItemPagesNameMixin
) {
  'use strict';

  var localStorageKeyProductView = 'productSupplierView';

  var SuppliersRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'suppliers/imprintTechnologies': 'showSupplierImprintTechnologies'
    },
    onRoute: function () {

    }
  });

  var API = {
      showSupplierImprintTechnologies: function() {
          var self = this; // Store reference to 'this'

          ContentShowController.showContent().done(function() {

              self.supplierImprintTechnologiesView = new SupplierImprintTechnologiesView();
              App.regions.getRegion('main').currentView.getRegion('content').show(self.supplierImprintTechnologiesView);
              App.startSubModule('adminMain');
              App.execute('set:active:nav:item', ItemPagesNameMixin.SUPPLIERS_IMPRINT_TECHNOLOGIES);
          });
    }
  };

  App.on('productsSupplier:show', function () {
    App.navigate('productsSupplier');
    API.showProducts();
  });

  App.on('productsSupplier:show:grid', function() {
    Settings.setToMemory(localStorageKeyProductView, 'grid');
    App.navigate('productsSupplier');
    API.showProductsGrid();
  });

  App.on('before:start', function () {
    new SuppliersRouter({
      controller: API
    });
  });

  module.exports = SuppliersRouter;
});
